import React, { useState, useEffect } from 'react';
import './Graduates.css';
import axios from 'axios';

const Graduates = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // News API çağrısı
        const newsResponse = await axios.get('http://127.0.0.1:8000/api/v1/news/');
        console.log('News API response status:', newsResponse.status);
        setNews(newsResponse.data);

        // Announcements API çağrısı - düzeltilmiş endpoint
        const announcementsResponse = await axios.get('http://127.0.0.1:8000/api/v1/announcements/');
        console.log('Announcements API response status:', announcementsResponse.status);
        setAnnouncements(announcementsResponse.data);

        setLoading(false);
      } catch (error) {
        console.error('API verisi çekilirken hata:', error);
        // Hata durumunda mock veri kullanılıyor
        console.log('Hata nedeniyle mock veri kullanılıyor...');
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const graduatePrograms = [
    {
      id: 1,
      name: 'Aktüerya Bilimleri',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop',
      link: '#',
      description: 'Risk analizi ve finansal modelleme'
    },
    {
      id: 2,
      name: 'Biyoloji',
      image: 'https://images.unsplash.com/photo-1628773822503-930a7eaecf80?w=400&h=250&fit=crop',
      link: '#',
      description: 'Yaşam bilimlerinin temelleri'
    },
    {
      id: 3,
      name: 'Biyoteknoloji',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop',
      link: '#',
      description: 'Modern biyolojik teknolojiler'
    },
    {
      id: 4,
      name: 'Botanik',
      image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=250&fit=crop',
      link: '#',
      description: 'Bitki bilimleri ve ekolojisi'
    },
    {
      id: 5,
      name: 'Ekoloji',
      image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&h=250&fit=crop',
      link: '#',
      description: 'Çevre ve ekosistem araştırmaları'
    },
    {
      id: 6,
      name: 'Hidrobiyoloji',
      image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=250&fit=crop',
      link: '#',
      description: 'Su canlıları ve ekosistemleri'
    },
    {
      id: 7,
      name: 'Genel Biyoloji',
      image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=400&h=250&fit=crop',
      link: '#',
      description: 'Kapsamlı biyoloji araştırmaları'
    },
    {
      id: 8,
      name: 'Moleküler Biyoloji',
      image: 'https://images.unsplash.com/photo-1579952363873-27d3bfad9c0d?w=400&h=250&fit=crop',
      link: '#',
      description: 'Hücresel ve moleküler süreçler'
    },
    {
      id: 9,
      name: 'Uygulamalı Biyoloji',
      image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?w=400&h=250&fit=crop',
      link: '#',
      description: 'Biyolojinin pratik uygulamaları'
    },
    {
      id: 10,
      name: 'Zooloji',
      image: 'https://images.unsplash.com/photo-1564349683136-77e08dba1ef7?w=400&h=250&fit=crop',
      link: '#',
      description: 'Hayvan bilimleri ve davranışları'
    },
    {
      id: 11,
      name: 'İstatistik',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop',
      link: '#',
      description: 'Veri analizi ve istatistiksel modelleme'
    },
    {
      id: 12,
      name: 'Veri Bilimi',
      image: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=400&h=250&fit=crop',
      link: '#',
      description: 'Büyük veri ve yapay zeka'
    },
    {
      id: 13,
      name: 'Kimya',
      image: 'https://images.unsplash.com/photo-1554475901-4538ddfbccc2?w=400&h=250&fit=crop',
      link: '#',
      description: 'Moleküler ve analitik kimya'
    },
    {
      id: 14,
      name: 'KBRN Tehditleri ve Yönetimi',
      image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=400&h=250&fit=crop',
      link: '#',
      description: 'Güvenlik ve risk yönetimi'
    },
    {
      id: 15,
      name: 'Matematik',
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=250&fit=crop',
      link: '#',
      description: 'İleri matematik ve uygulamalar'
    }
  ];



  return (
    <div className="graduates-page">
      <div className="graduates-container">
        <div className="graduates-header">
          <h1 className="graduates-title">Yüksek Lisans ve Doktora Programları</h1>
          <p className="graduates-subtitle">
            Fen Fakültesi bünyesinde sunulan lisansüstü eğitim programlarımız
          </p>
        </div>

        <div className="programs-grid">
          {graduatePrograms.map((program) => (
            <div key={program.id} className="program-card" onClick={() => window.open(program.link, '_blank')}>
              <div className="program-image">
                <img src={program.image} alt={program.name} />
                <div className="program-overlay">
                  <div className="program-content">
                    <h3 className="program-name">{program.name}</h3>
                    <p className="program-description">{program.description}</p>
                    <div className="program-button">
                      <span>Programa Git →</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Graduates; 